import { readReleaseSession, resolveWorkspaceVariant, validateStableManifest } from './lib/workspaceRelease.js'

const sessionToken = () => readReleaseSession(localStorage, sessionStorage, location.hostname)
const apiBase = import.meta.env.VITE_API_BASE_URL || '/api'

async function variant(token) {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 4000)
  try { return await resolveWorkspaceVariant(fetch, token, apiBase, controller.signal) }
  finally { clearTimeout(timeout) }
}

function offerReload(current) {
  if (document.getElementById('workspace-release-update')) return
  const bar = document.createElement('aside')
  bar.id = 'workspace-release-update'
  bar.setAttribute('role', 'status')
  const ru = (localStorage.getItem('admin_lang') || 'ru') === 'ru'
  Object.assign(bar.style, { position: 'fixed', bottom: '16px', right: '16px', zIndex: '10000',
    padding: '12px', borderRadius: '10px', background: '#18261f', color: 'white', font: '14px system-ui',
    boxSizing: 'border-box', maxWidth: 'min(360px, calc(100vw - 32px))' })
  bar.append(document.createTextNode(ru ? 'Доступна другая версия интерфейса. Сохраните незавершённую работу. '
    : 'Another interface version is available. Save any unfinished work. '))
  const button = document.createElement('button')
  button.textContent = current === 'canary' ? (ru ? 'Открыть стабильную версию' : 'Open stable version')
    : (ru ? 'Открыть обновление' : 'Open update')
  button.addEventListener('click', () => location.reload())
  bar.append(button)
  document.body.append(bar)
}

async function start() {
  if (import.meta.env.DEV) {
    await import('./main.jsx')
    return
  }
  const token = sessionToken()
  const chosen = await variant(token)
  document.documentElement.dataset.workspaceRelease = chosen
  if (chosen === 'canary') {
    await import('./main.jsx')
  } else {
    const response = await fetch('/workspace-release.json', { cache: 'no-store' })
    if (!response.ok) throw new Error('Stable workspace manifest unavailable')
    const stable = validateStableManifest(await response.json())
    await Promise.all(stable.styles.map((href) => new Promise((resolve, reject) => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = href
      link.onload = resolve
      link.onerror = reject
      document.head.append(link)
    })))
    const script = document.createElement('script')
    script.type = 'module'
    script.src = stable.entry
    document.head.append(script)
  }
  // Authentication changes must never reuse another account's mounted workspace.
  setInterval(() => { if (sessionToken() !== token) location.reload() }, 1000)
  let checking = false
  const recheck = async () => {
    if (checking || document.visibilityState === 'hidden') return
    checking = true
    try { if (await variant(token) !== chosen) offerReload(chosen) }
    finally { checking = false }
  }
  setInterval(recheck, 60000)
  window.addEventListener('focus', recheck)
}

start().catch(() => {
  document.getElementById('root').textContent = 'Не удалось загрузить интерфейс. Обновите страницу.'
})
